export const FETCH_SCHOOL_DETAILS = 'FETCH_SCHOOL_DETAILS';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const UPDATE_ACCOMMODATION = 'UPDATE_ACCOMMODATION';
export const UPDATE_ADDITIONAL_SERVICE = 'UPDATE_ADDITIONAL_SERVICE';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';
export const UPDATE_INSURANCE = 'UPDATE_INSURANCE';
export const OPEN_CLOSE_LEAD_DIALOG = 'OPEN_CLOSE_LEAD_DIALOG';
export const SET_DEPOSIT = 'SET_DEPOSIT';
